const setDropdownText = (checkedCount, text) => {
    const mobile = window.matchMedia("(max-width: 1024px)");
    if (!checkedCount > 0) {
        return text;
    } else {
        if (mobile.matches) {
            return "Selection";
        } else {
            return text;
        }
    }
};

const handleDropdownClose = () => {
    // Target the specific buttons created in the Paint Layout
    const buttons = document.querySelectorAll(".js-accordion-trigger");

    buttons.forEach((button) => {
        const parent = button.parentElement;

        const closeMenu = () => {
            parent.classList.remove("dropdown-list-focus");
            button.setAttribute("aria-expanded", "false");
            const content = document.getElementById(
                button.getAttribute("aria-controls")
            );
            if (content) content.hidden = true;
        };

        const openMenu = () => {
            // Close all others first
            buttons.forEach((otherBtn) => {
                if (otherBtn !== button) {
                    otherBtn.parentElement.classList.remove(
                        "dropdown-list-focus"
                    );
                    otherBtn.setAttribute("aria-expanded", "false");
                    const otherContent = document.getElementById(
                        otherBtn.getAttribute("aria-controls")
                    );
                    if (otherContent) otherContent.hidden = true;
                }
            });
            // Open current
            parent.classList.add("dropdown-list-focus");
            button.setAttribute("aria-expanded", "true");
            const content = document.getElementById(
                button.getAttribute("aria-controls")
            );
            if (content) content.hidden = false;
        };

        // EVENT: CLICK on button
        button.addEventListener("click", (e) => {
            e.stopPropagation();
            // Toggle state
            const isOpen = button.getAttribute("aria-expanded") === "true";
            isOpen ? closeMenu() : openMenu();
        });

        // EVENT: CLICK anywhere on dropdown select container (eliminates arrow / edge blind spots)
        parent.addEventListener("click", (e) => {
            if (e.target.closest(".js-accordion-trigger")) {
                return; // Handled by button listener
            }
            if (e.target.closest(".dropdown-list")) {
                return; // Never toggle or close when clicking inside dropdown content
            }
            e.stopPropagation();
            const isOpen = button.getAttribute("aria-expanded") === "true";
            isOpen ? closeMenu() : openMenu();
        });

        // EVENT: ESCAPE KEY (Accessibility requirement)
        parent.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
                const isOpen = button.getAttribute("aria-expanded") === "true";
                if (isOpen) {
                    e.preventDefault();
                    e.stopPropagation();
                    closeMenu();
                    button.focus(); // Return focus to the trigger
                }
            }
        });
    });

    // GLOBAL: Click Outside
    document.addEventListener("click", (e) => {
        const isClickInside = e.target.closest(".c-filters__dropdown-select") || e.target.closest(".dropdown-list");
        if (!isClickInside) {
            buttons.forEach((btn) => {
                if (btn.getAttribute("aria-expanded") === "true") {
                    btn.parentElement.classList.remove("dropdown-list-focus");
                    btn.setAttribute("aria-expanded", "false");
                    const c = document.getElementById(
                        btn.getAttribute("aria-controls")
                    );
                    if (c) c.hidden = true;
                }
            });
        }
    });
};

const handleDateFocus = () => {
    const dateFrom = document.querySelector(".fbjs-date-from");
    const dateTo = document.querySelector(".fbjs-date-to");
    const resetButton = document.getElementById("resetFilters");

    // Helper to find next interactive element if Reset button is hidden (Desktop)
    const focusNextVisibleElement = (currentElement) => {
        const focusableSelectors =
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        const allFocusable = Array.from(
            document.querySelectorAll(focusableSelectors)
        );
        const currentIndex = allFocusable.indexOf(currentElement);

        for (let i = currentIndex + 1; i < allFocusable.length; i++) {
            const el = allFocusable[i];
            // Must have size and not be part of the date trap
            if (
                el.offsetWidth > 0 &&
                el.offsetHeight > 0 &&
                !el.closest(".date-picker-container")
            ) {
                el.focus();
                return true;
            }
        }
        return false;
    };

    if (dateFrom && dateTo) {
        // Trap TAB on "From" -> Jump to "To"
        dateFrom.addEventListener("keydown", (e) => {
            if (e.key === "Tab" && !e.shiftKey) {
                e.preventDefault();
                dateTo.focus();
            }
        });

        // Trap TAB on "To"
        dateTo.addEventListener("keydown", (e) => {
            if (e.key === "Tab" && e.shiftKey) {
                // SHIFT+TAB -> Jump back to "From"
                e.preventDefault();
                dateFrom.focus();
            } else if (e.key === "Tab" && !e.shiftKey) {
                // TAB -> Jump to Next Valid Element
                e.preventDefault();
                if (
                    resetButton &&
                    resetButton.offsetWidth > 0 &&
                    resetButton.offsetHeight > 0
                ) {
                    resetButton.focus();
                } else {
                    const found = focusNextVisibleElement(dateTo);
                    if (!found) dateTo.blur();
                }
            }
        });

        // Allow ESC to close calendar
        const handleEsc = (e) => {
            if (e.key === "Escape") e.target.blur();
        };
        dateFrom.addEventListener("keydown", handleEsc);
        dateTo.addEventListener("keydown", handleEsc);
    }
};

/**
 * Universal Dropdown Handler
 * Dynamically binds to any dropdown selector or all .c-filters__dropdown-select elements
 */
export const handleDropdown = async (type, selector) => {
    const mobile = window.matchMedia("(max-width: 1024px)");
    const targets = selector ? document.querySelectorAll(selector) : document.querySelectorAll(".dropdown-list");

    targets.forEach((target) => {
        const dropdownContainer = target.closest(".c-filters__dropdown-select");
        if (!dropdownContainer) return;

        const selectTitle = dropdownContainer.querySelector(".c-filters__dropdown-title");
        const defaultTitle = dropdownContainer.getAttribute("data-title") || type || selectTitle?.innerText.trim() || "Filter";

        let defText = mobile.matches ? "Selection" : defaultTitle;
        if (target.classList.contains("geography") && mobile.matches) {
            defText = "Region";
        }
        if (selectTitle) {
            selectTitle.innerText = setDropdownText(0, defText);
        }

        const updateSelectionUI = () => {
            const checkedBoxes = Array.from(target.querySelectorAll("input[type=checkbox]:checked"));
            const width = window.innerWidth;

            if (checkedBoxes.length > 0) {
                dropdownContainer.classList.add("dropdownActive");
                if (selectTitle) {
                    if (width < 1200) {
                        selectTitle.innerText = `${checkedBoxes.length} selected`;
                    } else {
                        selectTitle.innerText = defaultTitle;
                    }
                }
            } else {
                dropdownContainer.classList.remove("dropdownActive");
                if (selectTitle) {
                    selectTitle.innerText = width > 1200 ? defaultTitle : "Selection";
                }
            }
        };

        // Bind change listener on checkboxes (using event delegation on target)
        if (!target._dropdownBound) {
            target.addEventListener("change", (e) => {
                if (e.target.matches("input[type=checkbox]")) {
                    const listItem = e.target.closest("li");
                    if (listItem) {
                        listItem.classList.toggle("dropdownActive", e.target.checked);
                    }
                    updateSelectionUI();
                }
            });

            // Re-sync when dynamic facets finish rendering
            target.addEventListener("facetsRendered", () => {
                updateSelectionUI();
            });

            target._dropdownBound = true;
        }

        // Initial state sync
        updateSelectionUI();
    });

    // Observer for active facet chips
    const observerCallback = () => {
        const width = window.innerWidth;
        const activeFacets = document.querySelectorAll(".active-facets span");
        let insightContainer = document.querySelector(".insights-facet") || null;
        let activeFacetsContainer = document.querySelector(".active-facets");
        let hasInsights = false;

        for (let i = 0; i < activeFacets.length; i++) {
            if (activeFacets[i].getAttribute("name") && activeFacets[i].getAttribute("name").includes("Insight")) {
                hasInsights = true;
                break;
            }
        }

        if (width < 1200 && !insightContainer && hasInsights && activeFacetsContainer) {
            let insightDiv = document.createElement("div");
            insightDiv.classList.add("insights-facet");
            activeFacets.forEach((facet) => {
                if (facet.getAttribute("name") && facet.getAttribute("name").includes("Insight")) {
                    insightDiv.appendChild(facet);
                }
            });
            activeFacetsContainer.appendChild(insightDiv);
        } else if (width < 1200 && insightContainer && !hasInsights) {
            insightContainer.remove();
        }
    };

    const targetNode = document.querySelector(".active-facets") || null;
    if (targetNode && !targetNode._insightsObserverBound) {
        const config = { childList: true, subtree: true };
        const mObserver = new MutationObserver(observerCallback);
        mObserver.observe(targetNode, config);
        targetNode._insightsObserverBound = true;
    }
};

/**
 * Universal Dropdown Initializer - binds all dropdowns (.key-markets, .geography, .solutions, etc.)
 */
export const initDropdownFilters = () => {
    handleDropdown("Sectors", ".key-markets");
    handleDropdown("Geography", ".geography");
    handleDropdown("Solutions", ".solutions");
    // Also bind any custom facet dropdowns
    document.querySelectorAll(".c-filters__dropdown-select").forEach(container => {
        const title = container.getAttribute("data-title") || "Filter";
        const list = container.querySelector(".dropdown-list");
        if (list && !list._dropdownBound) {
            handleDropdown(title, `#${list.id}`);
        }
    });
};

export const countAppliedFilters = async () => {
    const targets = document.querySelectorAll(".c-filters");
    let targetsArray = [...targets];
    let activeFacets = [];

    targetsArray.forEach((target) => {
        const facetsContainer = target?.querySelector(".active-facets");
        if (facetsContainer) {
            setAppliedFiltersCounter(target, facetsContainer);
            const observer = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (
                        mutation.type === "childList" ||
                        mutation.type === "subtree"
                    ) {
                        const facets = facetsContainer.querySelectorAll("span");
                        activeFacets.length = 0; // Clear previous entries
                        facets.forEach((element) => {
                            activeFacets.push(element.innerText);
                            element.tabIndex = 0;
                            element.addEventListener("keypress", (e) => {
                                if (e.key === "Enter") {
                                    element.click();
                                }
                            });
                        });
                        setAppliedFiltersCounter(target, facetsContainer);
                    }
                });
            });
            observer.observe(facetsContainer, {
                childList: true,
                subtree: true,
            });
        }
    });
};

window.dateInputsFilled = 0;
const setAppliedFiltersCounter = (target, facetsContainer) => {
    try {
        let activeFiltersCount = target.querySelector(
            ".c-filters__button--results"
        );
        activeFiltersCount.innerText =
            facetsContainer.childElementCount + window.dateInputsFilled;
    } catch {
        console.log(facetsContainer.childElementCount);
    }
};

const datePickerContainers = document.querySelectorAll(
    ".date-picker-container"
);
datePickerContainers.forEach((item) => {
    const observer = new MutationObserver(() => {
        let dateInputsFilled = document.querySelectorAll(
            ".date-filled-static"
        ).length;
        window.dateInputsFilled = dateInputsFilled;
        countAppliedFilters();
    });
    observer.observe(item, { attributes: true, childList: true });
});

window.addEventListener("DOMContentLoaded", () => {
    countAppliedFilters();
    handleDropdownClose();
    handleDateFocus();
});

// Backwards-compatible exports
export const handleEndMarketDropdown = () => {
    handleDropdown("Sectors", ".key-markets");
};

export const handleGeographyDropdown = () => {
    handleDropdown("Geography", ".geography");
};

export const handleSolutionsDropdown = () => {
    handleDropdown("Solutions", ".solutions");
};
